import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import ToolsPage from './pages/ToolsPage';
import AuditPage from './pages/AuditPage';
import AuditResult from './pages/AuditResult';
import OnboardingPage from './pages/OnboardingPage';
import PaymentPage from './pages/PaymentPage';
import DashboardPage from './pages/DashboardPage';
import CustomerDashboard from './pages/CustomerDashboard';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndPolicies from './pages/TermsAndPolicies';
import RefundPolicy from './pages/RefundPolicy';
import GoogleConnectPage from './pages/GoogleConnectPage';
import OAuthCallbackPage from './pages/OAuthCallbackPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

const getDynamicBasename = () => {
  const path = window.location.pathname;
  const match = path.match(/^\/products\/([^/]+)/);
  return match ? `/products/${match[1]}` : '/';
};

// Route customers to CustomerDashboard, admins to the full DashboardPage
const SmartDashboard = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user1'));
    if (user?.role === 'customer') return <CustomerDashboard />;
  } catch { /* fall through */ }
  return <DashboardPage />;
};

function App() {
  return (
    <LanguageProvider>
      <Router basename={getDynamicBasename()}>
        <Routes>
          <Route element={<Layout />}> 
            <Route path="/" element={<HomePage />} />
            <Route path="/tools" element={<ToolsPage />} />
            <Route path="/audit" element={<AuditPage />} />
            <Route path="/audit/:id" element={<AuditResult />} />
            <Route path="/onboarding" element={<OnboardingPage />} />
            <Route path="/payment" element={<PaymentPage />} />
            <Route path="/dashboard" element={<SmartDashboard />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-policies" element={<TermsAndPolicies />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/connect-google" element={<GoogleConnectPage />} />
            <Route path="/oauth/callback" element={<OAuthCallbackPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
          </Route>
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;


